import { TFunction } from 'i18next'

import { MarketShopOrderStatus } from '@/models'

export const MARKET_SHOP_RESTAURANT_AUTO_RELOAD_KEY = 'MARKET_SHOP_RESTAURANT_AUTO_RELOAD_KEY'

export const maxOrderItemsShownInCard: number = 3

export const removeNewOrderStatusTimeoutMS: number = 45000

export const newOrderAlertAudio = new Audio('/sounds/market-shop-restaurant/new-order-alert.mp3')

export const orderStatusColumnsOrder: MarketShopOrderStatus[] = [
  'new',
  'in_progress',
  'awaiting_pickup',
  'completed',
  'declined',
]

export const getMarketShopRestaurantStatusLabelsMap = (
  t: TFunction<['market-shop-restaurant']>,
): Record<MarketShopOrderStatus, string> => ({
  awaiting_pickup: t('market-shop-restaurant:status.awaitingPickup'),
  completed: t('market-shop-restaurant:status.completed'),
  declined: t('market-shop-restaurant:status.declined'),
  in_progress: t('market-shop-restaurant:status.inProgress'),
  new: t('market-shop-restaurant:status.new'),
})
